<template>
    <div :class="$style['cats-css']">
        <div style="width: 100%;">
            <div :class="$style['home-subproduct-title']">
                <span style="margin-right: 10px">
                    {{ cname }}
                </span>
                <v-icon style="color: white">chevron_left</v-icon>
                <span>
                    {{ pname }}
                </span>
            </div>
        </div>
        <ProductList :purchaseAble="purchaseAble" :list="listP" :shop_id="shop_id"></ProductList>
        <div style="text-align: left;">
            <div :class="$style['home-subproduct-btn']">
                <v-btn role="button" v-ripple @click="goBasket">
                    <v-icon>shopping_cart</v-icon>
                </v-btn>
                <p v-if="num_basket != null && num_basket != 0">{{ num_basket }}</p>
            </div>
        </div>
    </div>
</template>
<script>
    import oracle from "@/utils/oracle";
    import ProductList from "@/pages/ProductList";
    import OrderList from "@/pages/OrderList";

    export default {
        name: "CatProducts",
        components: {
            ProductList
        },
        data() {
            return {
                oracle: oracle,
                categories: false,
                num_basket: null,
                purchaseAble: false,
                listP: [],
                shop_id: null,
                pname: this.$route.query.pname,
                cname: this.$route.query.cname,
            };
        },
        methods: {
            goBasket() {
                this.$router.push({name: 'Basket'})
            },
            CheckCount() {
                this.num_basket = oracle.getCount()
            }, getData() {
                oracle.axios(
                    "product/getList",
                    {"limit_by": 500, "offset_by": 0, "order_by": "priority", "parent_by": this.$route.query.id},
                    (res) => {
                        for (let i = 0; i < res.data.length; i++) {
                            res.data[i].product_quantity = 0
                            res.data[i].product_count = 0
                        }
                        this.listP = []
                        let array = res.data;
                        if (this.shop_id != null) {
                            oracle.axios(
                                "shop/getQuantities",
                                {shop_id: this.shop_id},
                                (response) => {
                                    let qtys = response.data;
                                    for (let i = 0; i < qtys.length; i++) {
                                        for (let j = 0; j < array.length; j++) {
                                            if (qtys[i].product_id == array[j].product_id) {
                                                array[j].product_quantity = parseInt(qtys[i].product_quantity)
                                            }
                                        }
                                    }
                                    this.listP = array
                                }
                            );
                        } else {
                            this.listP = array
                        }
                    }
                );
            }
        },
        mounted() {
            this.shop_id = this.$route.query.shop_id
            if (this.shop_id == null || this.shop_id.length == 0) {
                this.purchaseAble = false
                this.getData()
            } else {
                oracle.axios("shop/getOne", {shop_id: this.shop_id}, (response) => {
                    this.purchaseAble = response.data.shop_type == 0
                    this.getData()
                })
            }
            this.CheckCount()
            this.$root.$on('numBasket', () => {
                this.CheckCount()
            })
        },
    };
</script>
<style module>
    .cats-css {
        height: 100%;
        overflow: scroll;
    }

    .cats-css a {
        text-decoration: none;
    }

    .cats-css .home-subproduct-title {
        display: flex;
        justify-content: right;
        color: white;
        background-color: rgb(126, 195, 82);
        height: 40px;
        align-items: center;
    }

    .cats-css .home-subproduct-btn button {
        margin-bottom: 17px;
        position: fixed;
        bottom: 50px;
        left: 25px;
        border-radius: 50%;
        background-color: #7ec352 !important;
        color: white !important;
        display: block !important;
        height: 54px !important;
        min-width: 54px !important;
    }

    .cats-css .home-subproduct-btn p {
        background-color: #cc7540;
        position: fixed;
        bottom: 90px;
        left: 60px;
        border-radius: 50%;
        width: 25px;
        text-align: center;
        color: white;
        height: 25px;
        font-size: 12px;
        line-height: 25px;
    }
</style>
